import { Module } from 'vuex';
import { AccountInventoryResultDiffState } from './types';
import { RootState } from '../../types';
import { actions } from './actions';
import { mutations } from './mutations';

const namespaced: boolean = true;
export const state: AccountInventoryResultDiffState = {
    inventoryResultDiffs: undefined,
    inventoryResultDiffBasicInformation: undefined,
    inventoryResultDiffChangedAccountDetails: undefined,
    inventoryResultDiffAddedAccountDetails: undefined,
    inventoryResultDiffDeletedAccountDetails: undefined,
    inventoryResultDiffCount: 0,
    inventoryResultDiffChangedAccountDetailsCount: 0,
    inventoryResultDiffAddedAccountDetailsCount: 0,
    inventoryResultDiffDeletedAccountDetailsCount: 0,

    search: {
        isProcessing: false,
        isFetchSuccess: false,
        error: false,
        errorCode: undefined,
        errorMsg: undefined,
    },
    show: {
        isProcessing: false,
        isFetchSuccess: false,
        error: false,
        errorCode: undefined,
        errorMsg: undefined,
    },
    changedAccounts: {
        isProcessing: false,
        isFetchSuccess: false,
        error: false,
        errorCode: undefined,
        errorMsg: undefined,
    },
    addedAccounts: {
        isProcessing: false,
        isFetchSuccess: false,
        error: false,
        errorCode: undefined,
        errorMsg: undefined,
    },
    deletedAccounts: {
        isProcessing: false,
        isFetchSuccess: false,
        error: false,
        errorCode: undefined,
        errorMsg: undefined,
    },
    csv: {
        isProcessing: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
};

export const accountInventoryResultDiff: Module<AccountInventoryResultDiffState, RootState> = {
    namespaced,
    state,
    actions,
    mutations,
};
